// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/font.css
// module id = Z5ix
// module chunks = 12